import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DATE_FORMAT } from 'src/app/shared/constants';
import {
    DxButtonModule,
    DxDateBoxModule,
    DxFormModule,
    DxLoadPanelModule,
    DxRadioGroupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxValidationGroupModule,
    DxValidatorModule,
} from 'devextreme-angular';
import { IncidentCorrectiveActionDto, IncidentReportDto } from '@services';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';
import { ScrollSectionViewComponent } from '../scroll-section-view.component';

@Component({
    selector: 'app-root-cause-actions-section',
    imports: [
        CommonModule,
        DxToolbarModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxValidationGroupModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxSelectBoxModule,
        DxDateBoxModule,
        DxScrollViewModule,
        DxFormModule,
        DxRadioGroupModule,
        DxTextAreaModule,
        DxCheckBoxModule,
    ],
    templateUrl: './root-cause-actions-section.component.html',
})
export class RootCauseActionsSectionComponent extends ScrollSectionViewComponent {
    @Input() incidentReport: IncidentReportDto;
    @Input() isReadOnly: boolean = false;
    
    public dateFormat = DATE_FORMAT;
    
    addAction() {
        this.incidentReport.correctiveActions.push(
            IncidentCorrectiveActionDto.fromJS({
                actionItem: '',
                responsiblePerson: '',
                targetDate: null,
                completionDate: null,
            }),
        );


        this.scrollToSpecificSection('correctiveActionSection');
    }

    removeAction(index: number) {
        this.incidentReport.correctiveActions.splice(index, 1);
    }

    scrollWorkTrainingToSectionEnd(event: any) {
        if (event.value) {
            this.scrollToSpecificSection('WorkTrainingSection');
        }
    }

    private scrollToSpecificSection(sectionId: string) {
        setTimeout(() => {
            this.scrollToSection(sectionId);
        });
    }
}
